import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { Overlay, OverlayRef, OverlayConfig } from '@angular/cdk/overlay';
import { TemplatePortalDirective } from '@angular/cdk/portal';

import { TokensFieldComponent, TokenItem } from './tokens-field.component';
import { AutocompleteComponent } from './autocomplete.component';

interface FieldValue {
  displayed?: string,
  stored?: string
}

interface Suggestion {
  displayed?: string,
  secondary?: string,
  stored?: string
}

@Component({
  selector: 'app-autocomplete-tokens-field',
  templateUrl: './autocomplete-tokens-field.component.html',
  styleUrls: ['./autocomplete-tokens-field.component.scss']
})
export class AutocompleteTokensFieldComponent extends TokensFieldComponent {

  items: TokenItem[] = [];
  loading: boolean = false;
  matchRegex: RegExp;
  overlayRef: OverlayRef;
  selectedIndex: number;
  suggestions: Suggestion[] = [];
  values: FieldValue[];
  @ViewChild("fieldElement") fieldElement: ElementRef;
  @ViewChild("autocompleteTemplate") autocompleteTemplate: TemplatePortalDirective;
  @ViewChild("autocomplete") autocomplete: AutocompleteComponent;

  ngOnInit() {
    if (this.values == null) {this.values = this.field.values || []}
    super.ngOnInit();
  }

  emitValue() {
    let values = this.items.map((i) => i.value)
    this.valueChanged.emit({field: this.id, value: values})
  }
  
  onValueChange(value) {
    this.loading = false;
    this.clearSuggestions();

    if (value != null && value.trim() !== '') {
      let words = value.split(/\b/).map((w) => w.regExpEscape());
      this.matchRegex = new RegExp('(\\b' + words.join("|") + ')', 'gi');
    } else {
      this.matchRegex = null;
    }
    
    if (this.focused) {
      this.loading = true;
      this.cd.markForCheck();
      this.loadSuggestions(value);
    }
  }

  loadSuggestions(value) {
    if (value == null || value.trim() === '') {
      this.suggestions = this.values;
    } else {
      let regex = new RegExp("\\b" + value.regExpEscape(), 'gi');
      this.suggestions = this.values.filter((v) => regex.test(v.displayed));
      this.selectedIndex = 0;
    }
    if (this.suggestions.length > 0) {
      this.showSuggestions();
    }
    this.loading = false;
  }

  clearSuggestions() {
    this.suggestions = [];
    this.selectedIndex = null;
    if (this.overlayRef != null) {this.overlayRef.dispose()};
  }

  showSuggestions() {
    let config = new OverlayConfig();
    config.positionStrategy = this.overlay.position().connectedTo(
      this.fieldElement,
      {originX: 'start', originY: 'bottom'},
      {overlayX: 'start', overlayY: 'top'}
    );
    config.scrollStrategy = this.overlay.scrollStrategies.reposition();
    config.width = this.fieldElement.nativeElement.offsetWidth;
    this.overlayRef = this.overlay.create(config);
    this.overlayRef.attach(this.autocompleteTemplate);
  }

  validateItem(item) {
    item.valid = (this.values.find((v) => this.itemValuesEqual(v,item.value)) != null);
  }

  commitValue() {
    if (this.suggestions.length > 0) {
      this.commitSelected();
    } else {
      super.commitValue();
    }
  }

  commitSelected() {
    let index = this.autocomplete != null ? this.autocomplete.selectedIndex : null;
    if (index != null) {
      let suggestion = this.suggestions[index];
      if (suggestion != null) {
        let item = new TokenItem();
        item.value = {
          stored: suggestion.stored,
          displayed: suggestion.displayed
        };
        item.valid = true;
        this.addItem(item);
      }
      this.control.setValue('', {emitEvent: false});
    }
    this.clearSuggestions();
  }

  onFocus(event) {
    super.onFocus(event);
    this.matchRegex = null;
    this.loadSuggestions(null);
    return true;
  }

  onUpArrowKey() {
    if (this.autocomplete != null) {
      this.autocomplete.selectPrevious();
    }
    return false;
  }

  onDownArrowKey() {
    if (this.autocomplete != null) {
      this.autocomplete.selectNext();
    }
    return false;
  }

  autoSelected(index) {
    this.commitSelected();
  }

}


// WEBPACK FOOTER //
// ./src/app/forms/autocomplete-tokens-field.component.ts